/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleTypeTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleTypeFactory,
		FindAllArticleTypesByQueryParamsNonPageableFactory,
		NoPagingArticleTypeFactory,
		NoPagingPredefinedArticleTypeFactory
	) {
		$scope.articleTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newArticleType', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(articleType) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editArticleType', {
				articleTypeId: articleType.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getArticleTypeList = function() {
			FindAllArticleTypesByQueryParamsNonPageableFactory.query(
				{
					predefinedArticleTypeId: angular.isDefined($scope.predefinedArticleTypeId) ? $scope.predefinedArticleTypeId : null,

					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getArticleTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleTypeId = id;
			$('#deleteArticleTypeConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleTypeFactory.delete(
				{ id: $scope.selectedArticleTypeId },
				function() {
					$scope.loadAll();
					$('#deleteArticleTypeConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteArticleTypeConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
